import { instance } from "../api/axiosInstance";
const axios = instance;


export async function getScrapingStatus() {
    console.log("Fetching scraping status from API...",axios);
  return axios.get(`/aiScraper/scrapingStatus`);
}